import { FaBell } from "react-icons/fa";
import useNotificationBell from "../../hooks/useNotificationBell";
import PaginationNavigation from "./PaginationNavigation";

const badgeClasses =
    "absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full " +
    "bg-primary text-white text-[10px] font-bold leading-none " +
    "flex items-center justify-center";

const dropdownClasses =
    "absolute top-[calc(100%+8px)] left-0 z-[1000] w-[380px] " +
    "bg-surface rounded-lg border border-border-light " +
    "shadow-[0_4px_12px_rgba(0,0,0,0.12)] overflow-hidden";

const listClasses = "max-h-[280px] overflow-y-auto";

const itemClasses =
    "relative flex items-center gap-2.5 px-3.5 py-2.5 cursor-pointer " +
    "text-xs text-body border-b border-b-border-light " +
    "transition-colors duration-[220ms] hover:bg-surface-light";

const unreadDotClasses =
    "inline-block shrink-0 w-2 h-2 rounded-full " +
    "bg-primary";

const footerClasses =
    "flex items-center justify-between gap-2 px-3 py-2 " +
    "bg-surface-alt border-t border-t-border-light";

const footerInfoClasses = "text-[11px] text-subtle whitespace-nowrap";

const emptyClasses = "px-3.5 py-6 text-center text-xs text-subtle";

const NotificationBell = () => {
    const {
        wrapperRef, isOpen, handleBellClick, unreadCount, handleNotificationClick,
        pageItems, page, totalPages, startIndex, endIndex, totalCount, handlePageChange
    } = useNotificationBell();

    return (
        <div ref={wrapperRef} className="relative inline-block">
            <div onClick={handleBellClick} className="cursor-pointer">
                <FaBell />
                {unreadCount > 0 && (
                    <span className={badgeClasses}>
                        {unreadCount > 99 ? "99+" : unreadCount}
                    </span>
                )}
            </div>

            {isOpen && (
                <div className={dropdownClasses}>
                    <div className={listClasses}>
                        {pageItems.length === 0 ? (
                            <div className={emptyClasses}>No notifications</div>
                        ) : (
                            pageItems.map(({ _id, message, caseId, isRead, notificationType }) => (
                                <div
                                    key={_id}
                                    className={itemClasses}
                                    onClick={() => handleNotificationClick({ caseId, notificationId: _id, isRead, notificationType })}
                                >
                                    {!isRead && <span className={unreadDotClasses} />}
                                    <div>{message}</div>
                                </div>
                            ))
                        )}
                    </div>

                    {totalCount > 10 && (
                        <div className={footerClasses}>
                            <span className={footerInfoClasses}>
                                {startIndex}&ndash;{endIndex} of {totalCount}
                            </span>
                            <PaginationNavigation
                                currentPage={page}
                                totalPages={totalPages}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationBell;
